import api from './client'

/**
 * Authentication API Service
 * Handles all authentication endpoints
 */
export const authAPI = {
  /**
   * Login with email/username and password
   * POST /auth/login
   * 
   * Backend flow:
   * 1. POST /auth/login with username + password
   * 2. Backend validates credentials against User table
   * 3. Backend generates JWT access_token
   * 4. Returns {access_token, token_type, user: {...}}
   * 
   * Frontend stores token in localStorage under 'authToken'
   * Token is automatically added to all subsequent requests via interceptor
   */
  login: async (credentials) => {
    const response = await api.post('/auth/login', {
      email: credentials.email || credentials.username,
      password: credentials.password,
      rememberMe: Boolean(credentials.rememberMe),
      deviceType: "desktop"
    })
    return response.data
  },

  /**
   * Verify current token is valid
   * GET /auth/verify
   */
  verify: async () => {
    const response = await api.get('/auth/verify')
    return response.data
  },

  /**
   * Refresh token
   * POST /auth/refresh
   */
  refresh: async () => {
    const response = await api.post('/auth/refresh')
    return response.data
  },

  /**
   * Logout current session
   * POST /auth/logout
   */
  logout: async () => {
    const response = await api.post('/auth/logout')
    return response.data
  },

  /**
   * Request password reset
   * POST /auth/forgot-password
   */
  forgotPassword: async (email) => {
    const response = await api.post('/auth/forgot-password', { email })
    return response.data
  },

  /**
   * Verify OTP
   * POST /auth/verify-otp
   */
  verifyOtp: async (email, otp) => {
    const response = await api.post('/auth/verify-otp', {
      email,
      otp,
    })
    return response.data
  },

  /**
   * Change password
   * POST /auth/change-password
   */
  changePassword: async ({ email, newPassword, otp, currentPassword }) => {
    const response = await api.post('/auth/change-password', {
      email,
      newPassword,
      otp,
      currentPassword,
    })
    return response.data
  },

  /**
   * Get current user profile
   * GET /auth/me
   */
  getProfile: async () => {
    const response = await api.get('/auth/me')
    return response.data
  }
}
